/**
 * Supported FCM notification types for subscription.
 *
 * Named `FCMNotificationType` to distinguish from the UI `NotificationType`
 * enum used for notification tray rendering.
 */
export enum FcmNotificationType {
  /** Subscribe to all notification types (wildcard) */
  ALL = '*',
  /** Test notifications for development/debugging */
  TEST = 'TEST',
  /** A new in-app notification was created (triggers tray refresh) */
  NOTIFICATION_CREATED = 'NOTIFICATION_CREATED',
  /** Invoice generation completed */
  INVOICE_READY = 'INVOICE_READY',
  /** Bills generation completed */
  BILLS_READY = 'BILLS_READY',
  /** Team member created, updated, or deleted */
  TEAM_MEMBER_UPDATED = 'TEAM_MEMBER_UPDATED',
  /** Project created, updated, or deleted */
  PROJECT_UPDATED = 'PROJECT_UPDATED',
  /** Client created, updated, or deleted */
  CLIENT_UPDATED = 'CLIENT_UPDATED',
  /** Active timer started, paused, resumed, updated, stopped, or discarded */
  ACTIVE_TIMER_UPDATED = 'ACTIVE_TIMER_UPDATED',
}
